import RoundButton from '~/components/buttons/RoundButton.vue';
import SanityBlockContent from '~/components/sanity/SanityBlockContent.vue';
export default {
  name: 'SanityHeroModule',
  components: {
    RoundButton,
    SanityBlockContent
  },
  props: {
    content: {
      type: Object
    },
    layout: {
      type: Object
    },
    styles: {
      type: Object
    }
  },
  data() {
    return {};
  },
  computed: {
    imageRef() {
      return this.content.image.asset._ref;
    },
    styling() {
      if (!this.styles) {
        return {
          color: '#FFFFFF',
          backgroundColor: '#000000'
        };
      }
      let style = {
        color: this.styles.color || '#FFFFFF'
      };
      if (this.styles.backgroundType === 'image') {
        style = {
          ...style,
          backgroundImage: `url(${this.styles.backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        };
      } else if (this.styles.backgroundType === 'color') {
        style.backgroundColor = this.styles.backgroundColor;
      } else {
        style.backgroundColor = '#000000';
      }
      return style;
    }
  }
};